var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_162_9346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.376 12.4158L8.777 19.4818C8.70171 19.5319 8.61423 19.5607 8.52389 19.565C8.43355 19.5693 8.34373 19.5491 8.264 19.5064C8.18427 19.4637 8.1176 19.4002 8.07111 19.3226C8.02462 19.245 8.00005 19.1563 8 19.0658V4.93382C8.00005 4.84338 8.02462 4.75465 8.07111 4.67707C8.1176 4.59949 8.18427 4.53597 8.264 4.49328C8.34373 4.45059 8.43355 4.43033 8.52389 4.43465C8.61423 4.43897 8.70171 4.46772 8.777 4.51782L19.376 11.5838C19.4445 11.6295 19.5006 11.6913 19.5395 11.7639C19.5783 11.8365 19.5986 11.9175 19.5986 11.9998C19.5986 12.0821 19.5783 12.1632 19.5395 12.2357C19.5006 12.3083 19.4445 12.3702 19.376 12.4158Z",
    fill: "#13100F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_162_9346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayFill);
export default __webpack_public_path__ + "static/media/play-fill.79216a5d381aa77336bb1e0554ab3b8a.svg";
export { ForwardRef as ReactComponent };